import {
	Company,
	Execution,
	Person,
	WritSearchItem,
	WritSearchType,
} from '@models/teranet';

export const getSearchItemName = (searchItem: WritSearchItem): string => {
	if (searchItem?.type === WritSearchType.COMPANY) {
		return (searchItem.item as Company).name;
	} else if (searchItem?.type === WritSearchType.PERSON) {
		return `${(searchItem.item as Person).firstName} ${(searchItem.item as Person).lastName}`;
	} else if (searchItem?.type === WritSearchType.EXECUTION) {
		return (searchItem.item as Execution).number;
	}
};
